import styled from 'styled-components'
import spacing from 'styles/spacing'
import border from 'styles/border'
import { LabelBoxEnumStr } from '.'
import { LabelSemiBoldSmall } from '../FontsV2'

export const TitleMd = styled(LabelSemiBoldSmall)<{ type: LabelBoxEnumStr }>`
  font-size: 13px;
  ${({ type, theme }) =>
    type === 'infoLight' &&
    `
      font-weight: ${({ theme }) => theme.fontWeight.normal};
      color: ${theme.colors.infoDark}
    `}
  ${({ type, theme }) => type === 'errorLight' && ` color: ${theme.colors.errorLight} `}
  
  ${({ type, theme }) =>
    type === 'success' &&
    `
      font-weight:${({ theme }) => theme.fontWeight.normal};
      color: ${theme.colors.success}
    `}
`

export const TitleSm = styled(LabelSemiBoldSmall)<{ type: LabelBoxEnumStr }>`
  ${({ type, theme }) =>
    type === 'infoLight'
      ? `
    font-weight: ${({ theme }) => theme.fontWeight.normal};
    color: ${theme.colors.infoDark}
    `
      : ''}

  ${({ type, theme }) =>
    type === 'errorLight'
      ? `
      color: ${theme.colors.errorLight}
      `
      : ''}
`

export const LabelBoxWrapper = styled.div<{ type: LabelBoxEnumStr }>`
  display: flex;
  color: ${({ theme }) => theme.colors.base};
  padding: ${spacing.sm}px ${spacing.md}px;
  border-radius: ${border.radius.md}px;
  border-style: solid;
  border-width: ${border.width.md}px;

  ${({ type, theme }) =>
    type === 'success'
      ? `
    border-color: ${theme.colors.success};
    background-color: ${theme.colors.green100};
    `
      : ''}

  ${({ type, theme }) =>
    type === 'warning'
      ? `
    border-color: ${theme.colors.gold500};
    background-color: ${theme.colors.warningBg};
    `
      : ''}

  ${({ type, theme }) =>
    type === 'error'
      ? `
    border-color: ${theme.colors.errorLight};
    background-color: ${theme.colors.red100};
    `
      : ''}
  
  ${({ type, theme }) =>
    type === 'errorLight'
      ? `
    border-color: ${theme.colors.errorLight};
    background-color: ${theme.colors.gray100};
    `
      : ''}

  ${({ type, theme }) =>
    type === 'info'
      ? `
    border-color: ${theme.colors.infoDark};
    background-color: ${theme.colors.infoLightWhite};
    `
      : ''}

  ${({ type, theme }) =>
    type === 'infoLight'
      ? `
    border-color: ${theme.colors.infoDark};
    background-color: ${theme.colors.infoLightWhite};
    `
      : ''}
  
  ${({ type, theme }) =>
    type === 'infoDark'
      ? `
    border-color: ${theme.colors.infoDark};
    color: ${theme.colors.infoDark};
    background-color: ${theme.colors.infoLightWhite};
    `
      : ''}
`

export const IconWrapper = styled.div<{ type: LabelBoxEnumStr }>`
  position: relative;
  top: 1px;
  line-height: 1em;

  i {
    font-size: 14px;
    margin-right: ${spacing.sm}px;

    ${({ type, theme }) =>
      type === 'success'
        ? `
      font-size: 11px;
      color: ${theme.colors.success}
      `
        : ''}

    ${({ type, theme }) =>
      type === 'warning'
        ? `
      font-size: 18px;
      color: ${theme.colors.gold500}
      `
        : ''}

    ${({ type, theme }) =>
      type === 'error'
        ? `
      color: ${theme.colors.errorLight}
      `
        : ''}
      
    ${({ type, theme }) =>
      type === 'errorLight'
        ? `
      color: ${theme.colors.errorLight}
      `
        : ''}

    ${({ type, theme }) =>
      type === 'info' || type === 'infoLight'
        ? `
      color: ${theme.colors.infoDark}
      `
        : ''}
  }
`
